import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import htmlToDraft from 'html-to-draftjs';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import {
    ContentState,
    convertFromHTML,
    convertToRaw,
    DefaultDraftBlockRenderMap,
    EditorState,
    genKey,
    ContentBlock,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { Map } from 'immutable';
import { extractAppealFromState } from 'helpers';

import { setMailBody, setReplyMailBody } from '../../../actions/emails';

function mapStateToProps(state, props) {
    const [appeal, id] = extractAppealFromState(state, props);
    const email = get(state, `emails.emails[${id}]`, {});
    return {
        id,
        mailBody: email.mailBody,
        replyMailBody: email.replyMailBody,
    };
}
function SpoilerComponent({ setMailBody, setReplyMailBody, id, mailBody, replyMailBody }) {
    // add replyMailBody to mailBody
    function spoilerOpen(e) {
        // console.log('*** SPOILER OPEN ***');
        // e.stopPropagation();
        // e.preventDefault();
        // const rawContentState = convertToRaw(mailBody.getCurrentContent());
        // const mailBodyHTML = draftToHtml(rawContentState);
        const mailBodyHTML = toHtml(mailBody);

        const fullHtml = mailBodyHTML + replyMailBody;
        const parsedNewState = fromHtml(fullHtml, false, true);
        setMailBody(id, parsedNewState);
        setReplyMailBody(id, '');
    }

    return (
        <div className="email-spoiler" data-block="false" onClick={spoilerOpen}>
            <div className="email-spoiler--button">
                <i className="dot" />
                <i className="dot" />
                <i className="dot" />
            </div>
        </div>
    );
}

const Spoiler = withRouter(
    connect(mapStateToProps, { setMailBody, setReplyMailBody })(SpoilerComponent),
);

const Signature = ({ children }) => <div className="email-signature">{children}</div>;

const blockRenderMap = Map({
    spoiler: {
        element: 'spoiler',
        wrapper: <Spoiler />,
    },
    signature: {
        element: 'signature',
        wrapper: <Signature />,
    },
});

export const extendedBlockRenderMap = DefaultDraftBlockRenderMap.merge(blockRenderMap);

export function toHtml(mailBody, newSign, oldSign = '<p></p>') {
    let newSignRows = { blocks: [{ type: 'unstyled', key: 'signKey', text: '' }] };
    let oldSignRows = { blocks: [{ type: 'unstyled', key: 'signKey', text: '' }] };
    let oldSignText = [];
    let joinedArrayOldSignText = [];

    if (newSign) {
        const blocksFromHTML = convertFromHTML(newSign, undefined, extendedBlockRenderMap);

        const state = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap,
        );
        const signState = EditorState.createWithContent(state);

        const oldBlocksFromHTML = convertFromHTML(oldSign, undefined, extendedBlockRenderMap);
        const oldState = ContentState.createFromBlockArray(
            oldBlocksFromHTML.contentBlocks,
            oldBlocksFromHTML.entityMap,
        );
        const oldSignState = EditorState.createWithContent(oldState);

        newSignRows = { ...convertToRaw(signState.getCurrentContent()) };
        oldSignRows = { ...convertToRaw(oldSignState.getCurrentContent()) };
        oldSignText = oldSignRows.blocks.map((item) => item.text);
        joinedArrayOldSignText = oldSignText.join('');

        newSignRows.blocks.forEach((block) => {
            block.key = 'signKey';
            block.type = 'unstyled';
            block.code = 'signKey';
        });
    }

    const newRow = { ...convertToRaw(mailBody.getCurrentContent()) };

    newRow.blocks.forEach((block) => {
        if (block.type === 'spoiler') {
            block.type = 'unstyled';
            block.key = 'spoiler';
        }
        if (block.type === 'signature') {
            block.type = 'unstyled';
            block.key = 'signKey';
        }
    });

    if (newSign) {
        let blocks = newRow.blocks;

        if (oldSignText.length > 0) {
            const oldLen = oldSignText.length;
            const lastN = blocks.slice(-oldLen);
            const lastNTexts = lastN.map(b => b.text);

            const isOldSignMatch = lastNTexts.every((txt, idx) => txt === oldSignText[idx]);

            if (isOldSignMatch) {
                blocks = blocks.slice(0, -oldLen);
            }
        }

        const spoilerBlocks = blocks.filter(b => b.key === 'spoiler');
        const contentBlocks = blocks.filter(b => b.key !== 'spoiler');

        newRow.blocks = [
            ...contentBlocks,
            ...newSignRows.blocks,
            ...spoilerBlocks,
        ];
    }
    return draftToHtml(newRow);
}

export function fromHtml(mailBody = '', addBlock, withHtmlToDraft, messageBodyTemplate, signature) {
    const blocksFromHTML = withHtmlToDraft
        ? htmlToDraft(mailBody)
        : convertFromHTML(mailBody, undefined, extendedBlockRenderMap);

    // used to keep empty spaces from signature
    let signatureBlocks = [];
    if (!withHtmlToDraft && signature) {
        // we need to escape img tags from the signature since img is not supported in signatures
        const sign = htmlToDraft(signature.replace(/<img\b[^>]*>/g, ''));
        signatureBlocks = sign.contentBlocks;
        // blocksFromHTML.contentBlocks = [...messageBodyTemplateFromHTML.contentBlocks, ...blocksFromHTML.contentBlocks]
    }
    // used to keep empty spaces from messageBodyTemplateFromHTML
    let messageBodyBlocks = [];
    if (!withHtmlToDraft && messageBodyTemplate) {
        const messageBody = htmlToDraft(messageBodyTemplate);
        messageBodyBlocks = messageBody.contentBlocks;
        // blocksFromHTML.contentBlocks = [...messageBodyTemplateFromHTML.contentBlocks, ...blocksFromHTML.contentBlocks]
    }

    blocksFromHTML.contentBlocks = [...messageBodyBlocks, ...signatureBlocks, ...blocksFromHTML.contentBlocks];

    const newBlock = new ContentBlock({
        key: genKey(),
        type: 'unstyled',
        text: '',
    });

    if (addBlock) {
        blocksFromHTML.contentBlocks.splice(-1, 0, newBlock);
    }
    const state = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap,
    );

    try {
        return EditorState.createWithContent(state);
    } catch (e) {
        return EditorState.createEmpty();
    }
}

export function forwardTemplate({ mailBody, subject, date, from, to }) {
    return `<p>---------- Forwarded message ---------</p>
	<p>Від: ${from}</p>
	<p>Дата: ${date}</p>
	<p>Тема: ${subject || ""}</p>
	<p>Кому: ${to.join(', ')}</p>
	<br>${mailBody}`;
}

// export function replyTemplate({ mailBody }) {
//     return `<spoiler>${mailBody}</spoiler>`;
// }
export function replyTemplate({ mailBody }) {
    return `<spoiler></spoiler>`;
}

export function addSignature(signature) {
    return `<br/><signature>${signature}</signature>`;
}

export function changeSignature({ mailBody, sign = "", oldSign = "" }) {
    // we need to escape img tags from the signature since img is not supported in signatures
    const parsedSign =  sign.replace(/<img\b[^>]*>/g, '');
    const parsedOldSign = oldSign.replace(/<img\b[^>]*>/g, '');
    const blocksFromHTML = convertFromHTML(
        toHtml(mailBody, parsedSign, parsedOldSign),
        undefined,
        extendedBlockRenderMap,
    );

    const state = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap,
    );
    try {
        return EditorState.createWithContent(state);
    } catch (e) {
        return EditorState.createEmpty();
    }
}

export const EMAILNEW = 'EMAILNEW';
export const EMAILREPLY = 'EMAILREPLY';
export const EMAILREPLYALL = 'EMAILREPLYALL';
export const EMAILFORWARD = 'EMAILFORWARD';
export const INTERACTION_REQUEST = 'INTERACTION_REQUEST';
